const getAnonymizedName = (str: string) => {
  if (!str) return "";
  const prefixMatch = str.match(/^[^\p{L}\p{N}]+/u);
  const prefix = prefixMatch ? prefixMatch[0] : "";
  const normalized = str.replace(/_/g, " ");
  const words = normalized.match(/[\p{L}\p{N}]+/gu) || [];
  const firstLetters = words.map((word) => word[0]);
  return (prefix + firstLetters.join("")).toUpperCase();
};

export default getAnonymizedName;
